<div class="cancel-container">
    <h2 class="cancel-header">Reject Booking</h2>
    <hr>
    <p class="cancel-title">Are you sure want to reject the booking?</p>
    <div class="cancel-button-div">
        <button class="cancel-cancel-button" mat-flat-button (click)="close()">No</button>
        <button class="cancel-button" mat-flat-button (click)="approveRejectAppointment()">Yes</button>
    </div>
</div>